import {
  isAndroidUserAgent,
  isAppleUserAgent,
} from "@redotech/util/user-agent";

export enum WalletPlatform {
  APPLE = "apple",
  GOOGLE = "google",
}

type WalletPassResponse = Pick<Response, "blob" | "ok" | "status">;
type WalletPassFetcher = (url: string) => Promise<WalletPassResponse>;
type WalletPassSaver = (pass: Blob) => void;

export function getWalletPlatform(
  userAgent: string | undefined,
): WalletPlatform | undefined {
  if (!userAgent) {
    return undefined;
  }
  if (isAppleUserAgent(userAgent)) {
    return WalletPlatform.APPLE;
  }
  if (isAndroidUserAgent(userAgent)) {
    return WalletPlatform.GOOGLE;
  }
  return undefined;
}

export async function fetchAppleWalletPass({
  passUrl,
  fetchPass = (url) => fetch(url),
}: {
  passUrl: string;
  fetchPass?: WalletPassFetcher;
}): Promise<Blob> {
  const response = await fetchPass(passUrl);
  if (!response.ok) {
    throw new Error(`Unable to download Apple Wallet pass: ${response.status}`);
  }
  return response.blob();
}

export async function downloadAppleWalletPass({
  passUrl,
  fetchPass,
  savePass = (pass) => {
    const objectUrl = URL.createObjectURL(pass);
    const link = document.createElement("a");
    link.download = "happy-returns.pkpass";
    link.href = objectUrl;
    document.body.append(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  },
}: {
  passUrl: string;
  fetchPass?: WalletPassFetcher;
  savePass?: WalletPassSaver;
}): Promise<void> {
  const pass = await fetchAppleWalletPass({
    passUrl,
    ...(fetchPass && { fetchPass }),
  });
  savePass(pass);
}
